export default [
  {
    title: 'Магазин',
    route: 'shop',
    icon: 'ShoppingCartIcon',
    children: [
      {
        title: 'Товары',
        route: 'shop-products',
        icon: 'ShoppingBagIcon',
      },
      {
        title: 'Опции товаров',
        route: 'product-options',
        icon: 'FileTextIcon',
      },
      {
        title: 'Описания размеров',
        route: 'size-description',
        icon: 'FileTextIcon',
      },
      {
        title: 'Загрузка товаров',
        route: 'shop-upload',
        icon: 'UploadIcon',
      },
      {
        title: 'Управление категориями',
        route: 'shop-categories',
        icon: 'TabletIcon',
      },
      {
        title: 'Заказы',
        route: 'shop-orders',
        icon: 'ClipboardIcon',
      },
    ],
  },
  {
    title: 'Склад',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Новые товары',
        route: 'storage-new',
        icon: 'BoxIcon',
      },
    ],
  },
  {
    title: 'Старты',
    route: 'starts',
    icon: 'FlagIcon',
    children: [
      {
        title: 'Все старты',
        route: 'starts',
        icon: 'StarIcon',
      },
      {
        title: 'Серии',
        route: 'series',
        icon: 'LayersIcon',
      },
      {
        title: 'Архивы',
        route: 'archives',
        icon: 'ArchiveIcon',
      },
      {
        title: 'Календарь стартов',
        route: 'starts-calendar',
        icon: 'StarIcon',
      },
      {
        title: 'Шаблоны',
        route: 'templates',
        icon: 'StarIcon',
        children: [
          {
            title: 'Шаблоны групп',
            route: 'templates-groups',
            icon: 'StarIcon',
          },
          {
            title: 'Шаблоны промокодов',
            route: 'templates-promos',
            icon: 'StarIcon',
          },
          {
            title: 'Шаблоны персональных скидок',
            route: 'templates-discounts',
            icon: 'StarIcon',
          },
        ],
      },
      {
        title: 'Список команд',
        route: 'teams',
        icon: 'StarIcon',
      },
      {
        title: 'Города',
        route: 'starts-cities',
        icon: 'StarIcon',
      },
      {
        title: 'Сезоны',
        route: 'seasons',
        icon: 'SunIcon',
      },
      {
        title: 'Альбомы',
        route: 'albums',
        icon: 'BookOpenIcon',
      },
      {
        title: 'Донаты',
        route: 'donations',
        icon: 'DollarSignIcon',
      },
      {
        title: 'Комментарии',
        route: 'comments',
        icon: 'MessageCircleIcon',
      },
    ],
  },

  {
    title: 'Клубы',
    route: 'clubs',
    icon: 'SmileIcon',
    children: [
      {
        title: 'Тренировки',
        route: 'workouts',
        icon: 'ActivityIcon',
      },
      {
        title: 'Тренеры',
        route: 'trainers',
        icon: 'UserPlusIcon',
      },
      {
        title: 'Виды спорта',
        route: 'kindsofsports',
        icon: 'ListIcon',
      },
      {
        title: 'Расписания',
        route: 'schedules',
        icon: 'CalendarIcon',
      },
      {
        title: 'Абонементы',
        route: 'subscriptions',
        icon: 'DollarSignIcon',
      },
      {
        title: 'Запросы',
        route: 'requests',
        icon: 'SendIcon',
      },
      {
        title: 'Вопросы',
        route: 'questions',
        icon: 'HelpCircleIcon',
        children: [
          {
            title: 'Вопросы',
            route: 'questions',
            icon: 'HelpCircleIcon',
          },
          {
            title: 'Категории',
            route: 'questions-categories',
            icon: 'HelpCircleIcon',
          },
        ],
      },
      {
        title: 'Настройки страницы',
        route: 'clubs-settings',
        icon: 'SettingsIcon',
      },
    ],
  },
  {
    title: 'Новости',
    route: 'news',
    icon: 'MailIcon',
    children: [
      {
        title: 'Все новости',
        route: 'news',
        icon: 'MailIcon',
      },
      {
        title: 'Категории',
        route: 'news-categories',
        icon: 'ListIcon',
      },
    ],
  },
  {
    title: 'Пользователи',
    route: 'users',
    icon: 'UsersIcon',
  },
  {
    title: 'Уведомления',
    route: 'notifications',
    icon: 'BellIcon',
  },
  {
    title: 'Идентичность',
    icon: 'ShieldIcon',
    children: [
      { title: 'Серые профили', route: 'identity-grey-profiles', icon: 'UserIcon' },
      { title: 'Непривязанные результаты', route: 'identity-unmatched-results', icon: 'AlertTriangleIcon' },
      { title: 'Предложения результатов', route: 'identity-suggestions', icon: 'SendIcon' },
      { title: 'Запросы на привязку', route: 'identity-claims', icon: 'CheckSquareIcon' },
      { title: 'Конфликты владения', route: 'identity-conflicts', icon: 'GitMergeIcon' },
      { title: 'Запросы от пользователей', route: 'identity-missing-events', icon: 'CalendarIcon' },
      { title: 'Нормализация результатов', route: 'identity-results-normalization', icon: 'SlidersIcon' },
      { title: 'Аномалии дат', route: 'identity-anomalies', icon: 'AlertCircleIcon' },
      { title: 'Аудит', route: 'identity-audit', icon: 'ListIcon' },
      { title: 'Исправления данных', route: 'identity-corrections', icon: 'EditIcon' },
      { title: 'Запросы на объединение', route: 'identity-merge-requests', icon: 'GitMergeIcon' },
      { title: 'Статистика привязки', route: 'identity-stats', icon: 'BarChartIcon' },
      { title: 'Подозрительная активность', route: 'identity-security-events', icon: 'ShieldIcon' },
    ],
  },
  {
    title: 'Организаторы',
    route: 'organizers',
    icon: 'UserCheckIcon',
  },
  {
    title: 'Транзакции',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Получение статистики',
        route: 'statistics',
        icon: 'BoxIcon',
      },
    ],
  },
  {
    title: 'Диагностика оплат',
    icon: 'ActivityIcon',
    children: [
      { title: 'Проблемные платежи', route: 'payments-problems', icon: 'AlertTriangleIcon' },
      { title: 'Поиск платежей', route: 'payments-search', icon: 'SearchIcon' },
      { title: 'Журнал', route: 'payments-events', icon: 'ListIcon' },
    ],
  },
  {
    title: 'Виртуальные платежи',
    route: 'virtual-payment',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Кошельки',
        route: 'wallets',
        icon: 'CreditCardIcon',
      },
      {
        title: 'Транзакции',
        route: 'virtual-transactions',
        icon: 'CreditCardIcon',
      },
    ],
  },
  {
    title: 'Пользовательское',
    route: 'client',
    icon: 'BoxIcon',
    children: [
      {
        title: 'Публикации',
        route: 'posts',
        icon: 'BookOpenIcon',
      },
      {
        title: 'Внешние регистрации',
        route: 'external-registrations',
        icon: 'StarIcon',
      },
    ],
  },
  {
    title: 'Синхронизация',
    route: 'sync',
    icon: 'CloudIcon',
  },
  {
    title: 'Правила возврата',
    route: 'refund-rules',
    icon: 'RotateCcwIcon',
  },
  {
    title: 'Заглушка',
    route: 'maintenance',
    icon: 'AlertOctagonIcon',
    resource: 'ACL',
    action: 'manage',
  },
  {
    title: 'Маршрутизация фронтенда',
    route: 'frontend-routing',
    icon: 'GitBranchIcon',
    resource: 'ACL',
    action: 'manage',
  },
  {
    title: 'Распознавание номеров',
    route: 'bib-recognition',
    icon: 'HashIcon',
    resource: 'ACL',
    action: 'manage',
  },
  {
    title: 'Настройки',
    route: 'settings',
    icon: 'SlidersIcon',
    resource: 'ACL',
    action: 'manage',
  },
]
